export default __webpack_public_path__ + "static/media/vkycOptionScreen.5596c56a.png";